import React, { useState } from "react";
import Button from "@common/Button/Button";
import { MAIN_BUTTON } from "@constants";

import {
    CallToActionContainer,
    Title,
    Description,
    ButtonContainer,
    Input,
    InputWrapper,
    StyledFreeGuideButton
} from "./styled.js";

const EmailFormAction = ({
    title = "Download Our Guide to Documentation in Software Development!",
    description = "Our team gathered all the essential information about the documentation in software development. Find out about the crucial documents, what parts do they consist of, and get checklists to help you during the writing process. No more hassle and confusion! Just share your email address with us and get the Guide!",
    buttonText = "Yes, I want your FREE Guide!",
}) => {
    const [validStatus, setValidStatus] = useState(false);

    return (
        <CallToActionContainer id="form-action">
            <Title>{title}</Title>
            <Description>{description}</Description>
            <InputWrapper>
                <Input
                    id="email-input"
                    name="email"
                    type="email"
                    placeholder="Corporate email address"
                />

                <ButtonContainer>
                    {" "}
                    <StyledFreeGuideButton
                        id="send-email-button"
                        text={buttonText}
                        type={MAIN_BUTTON}
                        isDisabled={!validStatus}
                    />
                </ButtonContainer>
            </InputWrapper>
            <p id="error-message" />
        </CallToActionContainer>
    );
};

export default EmailFormAction;
